<template>
    <div class="form-group">
        <br>

        <ul class="tabs">
            <li :class="{ active : nav.active == 0}" @click="nav.active = 0">Dados</li>
            <li :class="{ active : nav.active == 1}" @click="nav.active = 1" v-if="type == 'edit' && form.group_id == null">Subgrupos</li>
        </ul>

        <mu-paper :z-depth="1">

            <mu-form :model="form">

                <!-- Nav 0 -->
                <div v-show="nav.active == 0">

                    <mu-row gutter>
                        <mu-col span="12" sm="12" md="8" lg="8" xl="8">

                            <!-- Nome -->
                            <mu-text-field v-model="form.name" full-width label="Título *"></mu-text-field>

                        </mu-col>
                        <mu-col span="12" sm="12" md="4" lg="4" xl="4">

                            <!-- Status -->
                            <mu-select label="Status" v-model="form.status" full-width>
                                <mu-option label="" :value="null"></mu-option>
                                <mu-option v-for="(item, key) in options.status" :key="key" :label="item.label" :value="item.value"></mu-option>
                            </mu-select>

                        </mu-col>
                    </mu-row>

                    <!-- Grupo -->
                    <mu-select label="Grupo" v-model="form.group_id" full-width v-if="!form.subGroups || form.subGroups.length == 0" help-text="Se o registro for um subgrupo selecione qual é o grupo.">
                        <mu-option label="Nenhum grupo" :value="null"></mu-option>
                        <mu-option v-for="(item, key) in options.groups" :key="key" :label="item.name" :value="item.id"></mu-option>
                    </mu-select>

                </div>

                <!-- Nav 1 -->
                <div v-show="nav.active == 1">
                    <div class="form-subgroups">
                        <mu-text-field v-model="subgroup.name" label="Adicionar subgrupo *" color="secondary"></mu-text-field>
                        <mu-button :disabled="!subgroup.name" round color="secondary" @click="saveSubgroupForm()">Adicionar</mu-button>
                    </div>
                    <mu-paper :z-depth="1" class="subgroups">
                        <mu-data-table :columns="options.columns" :data="form.subGroups" class="mu-table-custom">
                            <template slot="empty">
                                <div class="box-table-empty">
                                    Não foi encontrado registros de subgrupos.
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <td>{{ scope.row.name }}</td>
                                <td class="is-center importing">{{ scope.row.totalcontacts }}</td>
                                <td class="is-center">
                                    <mu-badge content="Inativo" v-if="scope.row.status == 'I'"></mu-badge>
                                    <mu-badge content="Ativo" v-if="scope.row.status == 'A'" color="success"></mu-badge>
                                </td>
                                <td class="is-center">
                                    <router-link :to="{ name: 'app.contacts.groups.edit', params: { id: scope.row.id } }">
                                        <font-awesome-icon icon="pen" class="icon-md " @click="loadAll()"/>
                                    </router-link>
                                </td>
                                <td class="is-center">
                                    <font-awesome-icon icon="times" class="icon-md  color-red cursor-pointer" @click="deleteSubgroupForm(scope.row)"/>
                                </td>
                            </template>
                        </mu-data-table>
                    </mu-paper>
                    <br>
                </div>

                <!-- Nav 2 -->
                <div v-show="nav.active == 2">
                    <div v-if="company.customType !== 'C'">

                        <mu-alert color="warning">
                             <font-awesome-icon icon="exclamation-triangle" class="icon-md icon-margin-left"/> Quando compartilhar o grupo com seus clientes eles também poderão enviar campanhas, porém só você poderá atualizar a lista de contatos do grupo e também poderá descompartilhar com os mesmos.
                        </mu-alert>

                        <br>

                        <!-- Compartilhar contatos deste grupo -->
                        <mu-form-item prop="checkbox">
                            <mu-checkbox v-model="form.shared" value="2" label="Compartilhar contatos deste grupo"></mu-checkbox>
                        </mu-form-item>

                        <!-- Clientes desta revenda -->
                        <mu-title color="secondary" type="h3" v-if="form.shared">{{ shared.length }} clientes selecionados para utilizar os contatos do grupo</mu-title>

                        <div class="dialog-box-search">
                            <font-awesome-icon icon="search" class="icon-md"/>
                            <input type="text" v-model="options.search" placeholder="_ Filtre seus clientes por nome">
                        </div>

                        <mu-paper :z-depth="1" class="shared" v-if="form.shared">
                            <mu-data-table :columns="options.clients_columns" :data="consumptionList" class="mu-table-custom">
                                <template slot-scope="scope">
                                    <td><mu-checkbox v-model="shared" :value="scope.row.id"></mu-checkbox></td>
                                    <td>{{ scope.row.nick_name }}</td>
                                    <td>{{ scope.row.document_id }}</td>
                                </template>
                            </mu-data-table>
                        </mu-paper>
                    </div>
                </div>

                <!-- Salvar -->
                <mu-flex class="actions">
                    <mu-button round color="primary" @click="saveForm()" :disabled="!form.name">
                        <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                        Salvar
                    </mu-button>
                    <mu-button round :to="{ name: 'app.contacts.groups' }">
                        Cancelar
                    </mu-button>
                </mu-flex>

                <!-- Lista de contatos do grupo -->
                <div v-if="nav.active == 0 && type == 'edit' && form && form.id">
                    <mu-divider></mu-divider>
                    <mu-group-contacts :id="form.id"></mu-group-contacts>
                </div>

            </mu-form>

        </mu-paper>

        <br>

        <!-- Bloco para excluir o grupo -->
        <mu-paper class="cancel" :z-depth="1" v-if="type == 'edit'">

            <!-- Pergunta para excluir o grupo  -->
            <mu-row justify-content="center" align-items="center">
                <mu-col span="12" sm="12" md="8" lg="8" xl="8">
                    <mu-flex class="title" justify-content="start" align-items="center">
                        <font-awesome-icon icon="exclamation-triangle" class="icon-md icon-margin-left color-red"/>
                        <strong>Excluir grupo</strong>
                    </mu-flex>
                    Todos os dados deste grupo serão perdidos e não terá como voltar.
                </mu-col>
                <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                    <div class="text-right">
                        <mu-button round color="error" @click="handleDialogDelete(true)">
                            <font-awesome-icon icon="trash" class="icon-md icon-margin-left"/>
                            Excluir
                        </mu-button>
                    </div>
                </mu-col>
            </mu-row>

            <!-- Dialogo para confirmar exclusão -->
            <mu-dialog title="Excluir o grupo" width="600" max-width="80%" :esc-press-close="false" :overlay-close="false" :open.sync="cancel.openDelete">
                Tem certeza que deseja excluir o grupo <strong>{{ form.name }}</strong>
                <mu-button slot="actions" round @click="handleDialogDelete(false)">Cancelar</mu-button>
                <mu-button slot="actions" round color="error" @click="deleteForm()">
                     <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                    Confirmar
                </mu-button>
            </mu-dialog>

        </mu-paper>

    </div>
</template>

<script>
    import GroupsServices from '@/services/contacts/groups'
    import ClientsServices from '@/services/settings/clients'

    export default {
        name: 'mu-form-group',
        props: ['type'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                options: {
                    subgroup: {
                        belong: false,
                        active: false
                    },
                    search: '',
                    clients: [],
                    clients_columns: [
                        { title: '', name: 'id', align: 'center', width: 50 },
                        { title: 'Cliente', name: 'name' },
                        { title: 'CNPJ/CPF', name: 'document' }
                    ],
                    groups: [],
                    status: [
                        { label: 'Inativo', value: 'I' },
                        { label: 'Ativo', value: 'A' }
                    ],
                    columns: [
                        { title: 'Subgrupo', name: 'name' },
                        { title: 'Contatos', name: 'contacts', align: 'center', width: 150 },
                        { title: 'Status', name: 'status', align: 'center', width: 150 },
                        { title: 'Editar', name: 'edit', align: 'center', width: 150 },
                        { title: 'Remover', name: 'remove', align: 'center', width: 150 }
                    ]
                },
                nav: {
                    active: 0
                },
                shared: [],
                form: {
                    group_id: '',
                    status: 'A',
                    sharedlist: []
                },
                subgroup: {
                    form: {}
                },
                cancel: {
                    openDelete: false
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Trás os dados da empresa gravadas no state
             */
            company () {
                return this.$store.state.company
            },

            // FILTRO DE BUSCA DOS CLIENTES DE UM GRUPO
            consumptionList () {
                return this.options.clients.filter((item) => {
                    return item.nick_name.toLowerCase().includes(this.options.search.toLowerCase())
                })
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        async mounted () {
            await this.loadAll()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝
        methods: {

            async loadAll () {
                this.form = {}

                // Carrega os clientes
                await this.loadClients()

                // Carrega os grupos
                await this.loadGroups()

                // Carrega os dados de grupos caso for editar
                if (this.type === 'edit') {
                    await this.loadForm()
                }

                // Verificando se exibimos subgrupos
                await this.checkSubgroups()
            },

            /**
             * Responsável por habilitar ou desabilitar o dialogo que excluir o grupo
             */
            handleDialogDelete (value) {
                this.cancel.openDelete = value
            },

            checkSubgroups () {
                if (this.type === 'edit') {
                    if ((this.form.subGroups && this.form.subGroups.length === 0) || this.form.subGroups === null) {
                        this.options.subgroup.active = true
                    }
                } else {
                    this.options.subgroup.active = true
                }
            },

            /**
             * Carrega os dados de clientes
             */
            async loadClients () {
                try {
                    let result = await ClientsServices.all()
                    if (result && result.status) {
                        this.options.clients = result.results
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os clientes.')
                }
            },

            /**
             * Carrega os dados de clientes
             */
            async loadGroups () {
                try {
                    let result = await GroupsServices.all({ group_only: true })
                    if (result && result.status) {
                        this.options.groups = result.results
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os grupos.')
                }
            },

            /**
             * Carrega os dados do grupo
             */
            async loadForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando os dados do grupo.')

                    this.nav.active = 0
                    this.form = {}

                    let result = await GroupsServices.find(this.$route.params.id)

                    if (result && result.status) {
                        this.form = result.results
                        if (this.form.group_id) {
                            this.options.subgroup.belong = true
                        }
                        this.options.groups = this.options.groups.filter((item) => {
                            return item.id !== this.form.id
                        })
                        this.formatClientsShared(this.form.sharedlist)
                        this.checkSubgroups()
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Salva os dados do grupo
             */
            async saveForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Salvando os dados do grupo.')

                    let result

                    let data = await this.treatment(this.form)

                    if (this.type === 'edit') {
                        result = await GroupsServices.update(data)
                    } else {
                        result = await GroupsServices.store(data)
                    }

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$router.push({ name: 'app.contacts.groups' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Salva os dados do grupo
             */
            async saveSubgroupForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Salvando os dados do subgrupo.')

                    let data = {
                        name: this.subgroup.name,
                        group_id: this.form.id,
                        status: 'A'
                    }

                    let result = await GroupsServices.store(data)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        await this.loadAll()
                        this.nav.active = 1
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Responsável por excluir o grupo
             */
            async deleteForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde, o grupo está sendo excluído.')

                    let result = await GroupsServices.destroy(this.form.id)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$router.push({ name: 'app.contacts.groups' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível excluir o item.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Responsável por excluir o grupo
             */
            async deleteSubgroupForm (data) {
                try {
                    this.$eventHub.$emit('loading', true, 'Salvando os dados do grupo.')

                    data.group_id = null

                    let result = await GroupsServices.update(data)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.form.subGroups = this.form.subGroups.filter((item) => {
                            return item.id !== data.id
                        })
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Faz o tratamento de dados do formulário antes de enviar
             */
            treatment (data) {
                data.sharedlist = this.shared.map((item) => {
                    return {
                        id_companiesshare: item
                    }
                })
                return data
            },

            /**
             * Retorna id do cliente compartilhado
             */
            async formatClientsShared (clients) {
                this.shared = clients.map((item) => {
                    let i = this.options.clients.find((i) => {
                        return i.id === item.id_companiesshare
                    })
                    return i.id
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .mu-divider
        margin 20px 0

    .form-group
        margin 20px 0

        .tabs
            list-style none
            margin-left -41px
            margin-bottom 12px
            li
                display inline
                padding 14px 20px
                cursor pointer
                border 1px #eee solid
                border-bottom 0
                margin-right 5px

                &.active
                    box-shadow(top, -5px, 5px, 0.10)
                    border-radius 3px 3px 0 0
                    background #fff
                    cursor auto
                    border 1px #eee solid
                    border-bottom 0
                    border-top 2px $secondary solid
                    color $secondary

        .actions
            .mu-button
                margin-right 5px

        .mu-paper
            padding 20px

        .form-subgroups
            margin-bottom 20px
            .mu-input
                width 100%
                margin-bottom 0

        h4
            margin 0

        .shared
            padding 0
            margin-bottom 15px

        .subgroups
            h2
                font-weight normal
                padding 10px 20px 6px 20px
                font-size 16px
                color $secondary
                margin 0
            &.mu-paper
                padding 0px

        .cancel
            background lighten(#F44336, 92%)
            padding 20px
            color #999
            border 1px #F44336 dotted

            .title
                svg
                    font-size 18px !important
                    color #F44336
                strong
                    font-size 16px
                    padding-left 5px
                    color #F44336

            .text-center
                text-align center

            .text-right
                text-align right

        .paginate
            padding 20px

        .cursor-pointer
            cursor pointer

    .dialog-box-search
        margin 15px 0px

        .icon-md
            position absolute
            margin 12px 0 0 12px

        input
            color $grey
            background lighten($grey, 90%)
            padding 10px 0
            text-indent 40px
            font-size 12px
            width 100%
            border 1px #ddd solid
            border-bottom-width 2px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)
        .form-subgroups
            .mu-input
                width 256px !important
                margin-right 10px !important
</style>
